'use client';

import React from 'react';
import { classnames } from '@/utils/classnames/classnames';
import { ResultsCountProps } from './types';

const ResultsCount = ({ count, noun, className }: ResultsCountProps) => {
  const word = count === 1 ? (noun?.singular ?? 'product') : (noun?.plural ?? 'products');

  return (
    <p
      className={classnames('text-13 text-gray-500', className)}
      role="status"
      aria-live="polite"
      data-testid="results-count"
    >
      {count.toLocaleString()} {word}
    </p>
  );
};

export default ResultsCount;
